<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <div>

    <mat-form-field class="full-width">
      <input matInput placeholder="Document Country (ISO Alpha 2 e.g. DE, AT, UK)" [(ngModel)]="data.documentCountry" />
    </mat-form-field>
    <mat-form-field class="full-width">
      <input matInput placeholder="Document Number" [(ngModel)]="data.documentNumber" />
    </mat-form-field>
    <div>
      <small>Document Expiry</small>
      <app-date-edit [(ngModel)]="data.documentExpiry"  placeholder="Valid until"></app-date-edit>
    </div>
    <div>
      <small>Document Type</small>
      <mat-select [(ngModel)]="data.documentType">
        <mat-option [value]="0" >NONE</mat-option>
        <mat-option [value]="1" >PASSPORT</mat-option>
        <mat-option [value]="2" >DRIVERS LICENSE</mat-option>
        <mat-option [value]="3" >ID CARD</mat-option>
        <mat-option [value]="4" >RESIDENCE PERMIT</mat-option>
        <mat-option [value]="99" >OTHER</mat-option>
      </mat-select>
    </div>

    <mat-form-field class="full-width">
      <input matInput placeholder="First name" [(ngModel)]="data.firstName" required/>
    </mat-form-field>
    <mat-form-field class="full-width">
      <input matInput placeholder="Last name" [(ngModel)]="data.lastName" required/>
    </mat-form-field>

    <app-date-edit [(ngModel)]="data.dob"  placeholder="Date of birth"></app-date-edit>

  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary">Update</button>
</div>
